import { Typography } from "@mui/material";
import React from "react";
import palette from "src/theme/palette";
import { EMPTY_VALUE_PLACEHOLDER, NO_LABEL, YES_LABEL } from "../ExploreTab.consts";

const PrimitiveCell = ({ value }) => {
  if (value === null || value === undefined || value === "") {
    return (
      <Typography variant="body2" sx={{ color: palette.text[600] }}>
        {EMPTY_VALUE_PLACEHOLDER}
      </Typography>
    );
  }

  if (typeof value === "boolean") {
    return (
      <Typography variant="body2" sx={{ color: palette.text[800] }}>
        {value ? YES_LABEL : NO_LABEL}
      </Typography>
    );
  }

  const text = typeof value === "object" ? JSON.stringify(value) : String(value);
  return (
    <Typography
      variant="body2"
      sx={{
        color: palette.text[800],
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }}
      title={text}
    >
      {text}
    </Typography>
  );
};

export default PrimitiveCell;
